import { z } from 'zod';
import { APIFactoryOptions, factory } from '../../config';

const policySave = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: 'policy/save',
		method: 'POST',
		requestSchema: z.object({
			encryptedJourneyId: z.string(),
			policyEffectiveDate: z.string().optional(),
			policyEndDate: z.string().optional(),
			userAcknowledgementIds: z.array(z.number().optional()),
		}),
		responseSchema: z.unknown().optional(),
	});

export default policySave;
